import MyPageLayout from "./MyPageLayout";
import MyPageHome from "./MyPageHome";
import "./MyPage.css";

export default function MyPage() {
  return (
    <MyPageLayout>
      <MyPageHome />
    </MyPageLayout>
  );
}
